module.exports = __webpack_public_path__ + "static/media/Reshenie_SD_Formoplast_OSA_GFO 2018.c9190ac6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Reshenie_SD_Formoplast_OSA_GFO 2018.pdf
// module id = 130
// module chunks = 0